import { css } from 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
var Dialog = {
  base: css(["border-radius:0px;"])
};
export default Dialog;